import { useSnackbar } from "notistack";
import { GameData, TeamTurns } from "../../../domain/model/Game";
import { Difficulty } from "../../../domain/model/Question";
import { PlayerRemoveFromUnfinishedGamesUseCase } from "../../../domain/usecase/player/RemoveFromUnfinishedGames/UseCase";
import { providePlayerGetCurrentInfoUseCase } from "../../di/UseCasesModule";
import { UserInfoViewModel } from "../home/avatar/UserInfoViewModel";
import { State } from "../../../domain/model/ResponseState";
import { useNavigate } from "react-router-dom";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import { showGlobalLoadingView } from "../../../core/utils/Utils";

export function UnfinishedGamesViewModel(
  playerRemoveFromUnfinishedGamesUseCase: PlayerRemoveFromUnfinishedGamesUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  function convertUnfinshedGameToGameData(unfinishedGame: string): GameData {
    const gameData = JSON.parse(unfinishedGame);

    gameData.categories.map((category: any) => {
      category.pointsHashmap = convertPointsHashmapStringToMap(
        category.pointsHashmap
      );
    });
    gameData.difficultiesMap = convertDifficultiesStringToMap(
      gameData.difficultiesMap
    );

    gameData.firstTeamLifelines.map((lifeline: any) => {
      lifeline.icon = require(`../../../${lifeline.icon}`);
    });
    gameData.secondTeamLifelines.map((lifeline: any) => {
      lifeline.icon = require(`../../../${lifeline.icon}`);
    });

    gameData.isUnfinished = true;

    return gameData;
  }

  function convertDifficultiesStringToMap(
    decodedJson: string
  ): Map<Difficulty, number> {
    const difficultiesMap: Map<Difficulty, number> = new Map();

    const easyDiffStart = "Difficulty.easy: ";
    const easyDiffend = "0";
    const easyDiffStartIndex = decodedJson.indexOf(easyDiffStart);
    const easyDiffEndIndex = decodedJson.indexOf(
      easyDiffend,
      easyDiffStartIndex + easyDiffStart.length
    );
    const easyDiff = decodedJson.substring(
      easyDiffStartIndex + easyDiffStart.length,
      easyDiffEndIndex + 1
    );

    const mediumDiffStart = "Difficulty.medium: ";
    const mediumDiffend = "0";
    const mediumDiffStartIndex = decodedJson.indexOf(mediumDiffStart);
    const mediumDiffEndIndex = decodedJson.indexOf(
      mediumDiffend,
      mediumDiffStartIndex + mediumDiffStart.length
    );
    const mediumDiff = decodedJson.substring(
      mediumDiffStartIndex + mediumDiffStart.length,
      mediumDiffEndIndex + 1
    );

    const hardDiffStart = "Difficulty.hard: ";
    const hardDiffend = "0";
    const hardDiffStartIndex = decodedJson.indexOf(hardDiffStart);
    const hardDiffEndIndex = decodedJson.indexOf(
      hardDiffend,
      hardDiffStartIndex + hardDiffStart.length
    );
    const hardDiff = decodedJson.substring(
      hardDiffStartIndex + hardDiffStart.length,
      hardDiffEndIndex + 1
    );

    difficultiesMap.set(Difficulty.EASY, Number(easyDiff));
    difficultiesMap.set(Difficulty.MEDIUM, Number(mediumDiff));
    difficultiesMap.set(Difficulty.HARD, Number(hardDiff));

    return difficultiesMap;
  }

  function convertPointsHashmapStringToMap(
    decodedJson: string
  ): Map<TeamTurns, Map<Difficulty, boolean>> {
    const pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>> = new Map();

    const teamAStart = "TeamTurns.teamA: {";
    const teamAend = "}";
    const teamAStartIndex = decodedJson.indexOf(teamAStart);
    const teamAEndIndex = decodedJson.indexOf(
      teamAend,
      teamAStartIndex + teamAStart.length
    );
    const teamADiffBool = decodedJson.substring(
      teamAStartIndex + teamAStart.length,
      teamAEndIndex
    );

    const teamAEasyDiffStart = "Difficulty.easy: ";
    const teamAEasyDiffend = "e";
    const teamAEasyDiffStartIndex = teamADiffBool.indexOf(teamAEasyDiffStart);
    const teamAEasyDiffEndIndex = teamADiffBool.indexOf(
      teamAEasyDiffend,
      teamAEasyDiffStartIndex + teamAEasyDiffStart.length
    );
    const teamAEasyDiff = teamADiffBool.substring(
      teamAEasyDiffStartIndex + teamAEasyDiffStart.length,
      teamAEasyDiffEndIndex + 1
    );

    const teamAMediumDiffStart = "Difficulty.medium: ";
    const teamAMediumDiffend = "e";
    const teamAMediumDiffStartIndex =
      teamADiffBool.indexOf(teamAMediumDiffStart);
    const teamAMediumDiffEndIndex = teamADiffBool.indexOf(
      teamAMediumDiffend,
      teamAMediumDiffStartIndex + teamAMediumDiffStart.length
    );
    const teamAMediumDiff = teamADiffBool.substring(
      teamAMediumDiffStartIndex + teamAMediumDiffStart.length,
      teamAMediumDiffEndIndex + 1
    );

    const teamAHardDiffStart = "Difficulty.hard: ";
    const teamAHardDiffend = "e";
    const teamAHardDiffStartIndex = teamADiffBool.indexOf(teamAHardDiffStart);
    const teamAHardDiffEndIndex = teamADiffBool.indexOf(
      teamAHardDiffend,
      teamAHardDiffStartIndex + teamAHardDiffStart.length
    );
    const teamAHardDiff = teamADiffBool.substring(
      teamAHardDiffStartIndex + teamAHardDiffStart.length,
      teamAHardDiffEndIndex + 1
    );

    const teamBStart = "TeamTurns.teamB: {";
    const teamBend = "}";
    const teamBStartIndex = decodedJson.indexOf(teamBStart);
    const teamBEndIndex = decodedJson.indexOf(
      teamBend,
      teamBStartIndex + teamBStart.length
    );
    const teamBDiffBool = decodedJson.substring(
      teamBStartIndex + teamBStart.length,
      teamBEndIndex
    );

    const teamBEasyDiffStart = "Difficulty.easy: ";
    const teamBEasyDiffend = "e";
    const teamBEasyDiffStartIndex = teamBDiffBool.indexOf(teamBEasyDiffStart);
    const teamBEasyDiffEndIndex = teamBDiffBool.indexOf(
      teamBEasyDiffend,
      teamBEasyDiffStartIndex + teamBEasyDiffStart.length
    );
    const teamBEasyDiff = teamBDiffBool.substring(
      teamBEasyDiffStartIndex + teamBEasyDiffStart.length,
      teamBEasyDiffEndIndex + 1
    );

    const teamBMediumDiffStart = "Difficulty.medium: ";
    const teamBMediumDiffend = "e";
    const teamBMediumDiffStartIndex =
      teamBDiffBool.indexOf(teamBMediumDiffStart);
    const teamBMediumDiffEndIndex = teamBDiffBool.indexOf(
      teamBMediumDiffend,
      teamBMediumDiffStartIndex + teamBMediumDiffStart.length
    );
    const teamBMediumDiff = teamBDiffBool.substring(
      teamBMediumDiffStartIndex + teamBMediumDiffStart.length,
      teamBMediumDiffEndIndex + 1
    );

    const teamBHardDiffStart = "Difficulty.hard: ";
    const teamBHardDiffend = "e";
    const teamBHardDiffStartIndex = teamBDiffBool.indexOf(teamBHardDiffStart);
    const teamBHardDiffEndIndex = teamBDiffBool.indexOf(
      teamBHardDiffend,
      teamBHardDiffStartIndex + teamBHardDiffStart.length
    );
    const teamBHardDiff = teamBDiffBool.substring(
      teamBHardDiffStartIndex + teamBHardDiffStart.length,
      teamBHardDiffEndIndex + 1
    );

    pointsHashmap.set(
      TeamTurns.teamA,
      new Map([
        [Difficulty.EASY, teamAEasyDiff == "true"],
        [Difficulty.MEDIUM, teamAMediumDiff == "true"],
        [Difficulty.HARD, teamAHardDiff == "true"],
      ])
    );

    pointsHashmap.set(
      TeamTurns.teamB,
      new Map([
        [Difficulty.EASY, teamBEasyDiff == "true"],
        [Difficulty.MEDIUM, teamBMediumDiff == "true"],
        [Difficulty.HARD, teamBHardDiff == "true"],
      ])
    );

    return pointsHashmap;
  }

  async function continueGame(index: number, gameData: GameData) {
    if (!(await removeFromUnfinishedGames(index))) return;
    navigate(ROUTE_ENDPOINTS.GAME, {
      state: gameData,
      replace: true,
    });
  }

  async function removeFromUnfinishedGames(index: number): Promise<boolean> {
    showGlobalLoadingView(true);
    const response = await playerRemoveFromUnfinishedGamesUseCase.invoke(index);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        return true;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }

    return false;
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    convertUnfinshedGameToGameData,
    continueGame,
    removeFromUnfinishedGames,
  };
}
